"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BaseContainer = _interopRequireDefault(require("./BaseContainer"));

var RouterContainer = _BaseContainer.default.create();

var _default = Object.assign(RouterContainer, {
  get: function get() {
    throw new Error('RouterContainer.get() is no longer supported. Use RouterContainer.getContainer().get() instead.');
  }
});

exports.default = _default;
module.exports = exports.default;